
import DnCheckbox from '@digitalnatives/checkbox';

export default {
    extends: DnCheckbox
};
